import { render, staticRenderFns } from "./CCheckbox.vue?vue&type=template&id=6c50ce70&scoped=true&"
import script from "./CCheckbox.vue?vue&type=script&lang=js&"
export * from "./CCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./CCheckbox.vue?vue&type=style&index=0&id=6c50ce70&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c50ce70",
  null
  
)

export default component.exports